import React, {useEffect} from 'react'
import Banner from '../../Components/Banner';
import RoomsComponent from '../../Components/Rooms';
import rooms from '../../Constants/rooms'
import categories from '../../Constants/categories'
import { useTranslation } from 'react-i18next';

function Rooms() {
    const { t } = useTranslation();
    const banner = {
        title : t('main.chooseYourRoom'),
        description : t('main.chooseYourRoomDesc'),
        navigation: [{title: t('main.rooms'), path: '/rooms'}]
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    return (
        <>
            <Banner data={banner} />

            <RoomsComponent items={rooms} categories={categories}/>
        </>
        
    );
}

export default Rooms